import md5 from 'md5'
import wxp from './wxp'

/**
 * @function 官方版本判断
 * @author by
 * @param v1 {string} 当前版本号
 * @param v2 {string} 支持版本号
 */
export const compareVersion = (v1: string, v2: string) => {
  const v1Arr = v1.split('.')
  const v2Arr = v2.split('.')
  const len = Math.max(v1Arr.length, v2Arr.length)

  while (v1Arr.length < len) {
    v1Arr.push('0')
  }
  while (v2Arr.length < len) {
    v2Arr.push('0')
  }

  for (let i = 0; i < len; i++) {
    // eslint-disable-next-line radix
    const num1 = parseInt(v1Arr[i])
    // eslint-disable-next-line radix
    const num2 = parseInt(v2Arr[i])
    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }
  return 0
}

/**
 * @function 获取时间
 * @author by
 */
export const getTimeTamp = () => {
  return Date.parse(new Date().toString()) / 1000
}

/**
 * @function 获取顶部高度
 * @return {number}
 * @author: by
 */
export const getStatusBarHeight = () => {
  const { statusBarHeight } = wxp.getSystemInfoSync()
  const { height, top, bottom } = wxp.getMenuButtonBoundingClientRect()
  const navHeihgt = height + top + bottom
  const topHeight = (statusBarHeight + navHeihgt) / 2
  return topHeight
}

/**
 * @function 获取导航栏+状态栏高度
 * @return {number}
 * @author guoxt
 */
export const getNavAndStatusBarHeight = () => {
  let rect
  const { statusBarHeight } = wxp.getSystemInfoSync()
  try {
    rect = wx.getMenuButtonBoundingClientRect ? wx.getMenuButtonBoundingClientRect() : null // 胶囊按钮位置信息
  } catch (e) {
    // 容错处理
    rect = {
      width: 87,
      height: 32,
      top: 50,
      right: 368
    }
  }
  const titleBarHeightNormal = (function () { // 导航栏高度
    const gap = rect.top - statusBarHeight // 动态计算每台手机状态栏到胶囊按钮间距
    return 2 * gap + rect.height
  })()
  const titleBarHeight = titleBarHeightNormal || 44
  return {
    statusBarHeight,
    titleBarHeight,
    topHeight: ~~(statusBarHeight + titleBarHeight)
  }
}

/**
 * @function 生成uuid 时间戳加随机数加用户信息
 * @author eleven
 * @param openId {string} 用户id
 */
 export const createRandomString = (openId: string) => {
  const _len: number = 32
  // 截取用户id
  const userStr = openId.substring(0,4)
  const timestampStr = (new Date().getTime()).toString() // 当前时间戳
  const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678' // 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
  const maxPos = $chars.length
  let str = ''
  for (let i = 0, length = _len - 19; i < length; i++) {
    str += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return  timestampStr + str + userStr
}

/**
 * @function 生成随机字符串，该字符串唯一
 * @author eleven
 * @param len {string} 所需生成字符串的长度
 */
 export const getRandomString = (len?: number) => {
  const _len: number = len || 32
  const timestampStr = (new Date().getTime()).toString() // 当前时间戳
  const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678' // 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
  const maxPos = $chars.length
  let str = ''
  for (let i = 0, length = _len - 13; i < length; i++) {
    str += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return  str + timestampStr
}

/**
 * @function 对象数组去重
 * @param arr 要去重的数组
 * @param prop 属性
 */
export function arrDistinctByProp(arr, prop){
  let obj = {}
  return arr.reduce((preValue, item) => {
      obj[item[prop]] ? '' : obj[item[prop]] = true && preValue.push(item);
      return preValue
  },[])
}

/**
 * @funtion 排序数组对象
 * @param arr 需要排序的数组对象
 * @param key 以什么字段排序
 */
export const sortArrayObj = (arr, key) => {
  return arr.sort((a, b) => {
    const k1 = a[key]
    const k2 = b[key]
    if (k1 < k2) {
      return -1
    } else if (k1 > k2) {
      return 1
    } else {
      return 0
    }
  })
}
/**
 * @funtion 生成签名
 * @param {object} reqParams 接口请求的参数
 * @param {string} salt 盐
*/
export const generateSign = (reqParams, salt) => {
  const params = sortArrayObj(Object.entries(reqParams), 0).reduce(function (acc, cur) {
    acc[cur[0]] = cur[1]
    return acc
  }, {})
  const body = (Object.keys(params).reduce((qs, key) => `${qs}&${key}=${params[key]}`, '').slice(1) + salt).replace(/\\/g, '') // 加密的时候需要去掉反斜杠
  return md5(body)
}
